<template>
  <li class="sj-question-file-item sj-question-file-progress">
    <el-progress type="circle"
                 :width="75"
                 v-bind="$attrs"
                 v-on="$listeners"></el-progress>
  </li>
</template>

<script>

export default {
  components: {},
  mixins: [],
  inheritAttrs: false,
  props: {},
  data () {
    return {}
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {},
  destroyed () {},
  methods: {},
}
</script>
<style lang="scss">
.sj-question-file-progress {
}
</style>



// WEBPACK FOOTER //
// src/views/question-editor/packages/sj-question-file/src/SjQuestionFileProgress.vue